import { DivIcon, Marker, Util } from "leaflet";
import { Injectable } from "@angular/core";
import { UserLayerService } from ".";
import { LayerService } from "./layer.service";

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private userPosition: GeolocationPosition | null = null;

  constructor(private readonly layerService: LayerService, private readonly userLayerService: UserLayerService) { }

  getLocationAndMove(): boolean {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.userPosition = position;
          this.layerService.moveTo(this.userPosition.coords.latitude, this.userPosition.coords.longitude, 14);
          this.addUserMarker();
        }
      );
      return true;
    }
    return false;
  }

  removeLocation() {
    this.userLayerService.setUserMarker(undefined);
  }

  private addUserMarker() {
    if (this.userPosition != null) {
      const userColor = "#d42ca7";
      let ico = `<ellipse style="fill: rgb(255, 255, 255);" cx="250" cy="300" rx="175" ry="175"/><ellipse style = "stroke: rgb(0, 0, 0)" cx = "250" cy = "300" rx = "140" ry = "140" fill = "${userColor}" />`;

      let iconSettings = {
        mapIconUrl: `<svg class="trIco" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 540">${ico}</svg>`,
        mapIconColor: userColor
      };

      let divIcon = new DivIcon({
        className: "",
        html: Util.template(iconSettings.mapIconUrl, iconSettings),
        iconAnchor: [12, 14],
        iconSize: [25, 27],
        popupAnchor: [0, -16]
      });

      const marker = new Marker([this.userPosition.coords.latitude, this.userPosition.coords.longitude], { icon: divIcon });
      this.userLayerService.setUserMarker(marker);
    }
  }
}
